import "./autocomplete.styles.scss";
import AutoCompleteProvider from "./context";
import CompanySearch from "./containers/CompanySearch";

function AutoCompleteWidget({ inputClass, dropdownClass }) {
  return (
    <AutoCompleteProvider>
      <CompanySearch inputClass={inputClass} dropdownClass={dropdownClass} />
    </AutoCompleteProvider>
  );
}

AutoCompleteWidget.defaultProps = {
  inputClass: "autosuggest-widget-form-input",
  dropdownClass: undefined
};

export default AutoCompleteWidget;



// WEBPACK FOOTER //
// ./AutoComplete/index.js